import type { EGELayerRequest, GetCampaignResponse } from '../types';

const DAY_MS = 86400000;

/** The date range for flight and vessel evidence: the submitted fetch dates, never the editable Fetch draft. */
export const getAudienceTravelDateRange = (
  layers: EGELayerRequest[],
  campaign: GetCampaignResponse | null | undefined,
  start: number | null | undefined,
  end: number | null | undefined
): [number, number] => {
  const ranges: [number, number][] = [];
  for (const layer of layers) {
    if (!layer.enabled) continue;
    let observedStart = Infinity;
    let observedEnd = -Infinity;
    // Older saved layers have no query metadata; use their loaded observations.
    if (layer.queryDateRange?.[0] == null || layer.queryDateRange?.[1] == null) {
      for (const row of layer.data) {
        const timestamp = row.epochms ?? Date.parse(row.recordCreatedTime);
        if (!Number.isFinite(timestamp)) continue;
        observedStart = Math.min(observedStart, timestamp);
        observedEnd = Math.max(observedEnd, timestamp);
      }
    }
    const from = layer.queryDateRange?.[0] ?? observedStart;
    const to = layer.queryDateRange?.[1] ?? observedEnd;
    if (Number.isFinite(from) && Number.isFinite(to) && from <= to) ranges.push([from, to]);
  }
  if (ranges.length) return [Math.min(...ranges.map(([from]) => from)), Math.max(...ranges.map(([, to]) => to))];
  if (campaign) {
    const from = Date.parse(campaign.min_record_date ?? '');
    const to = Date.parse(campaign.max_record_date ?? '');
    if (Number.isFinite(from) && Number.isFinite(to)) return [from, to];
  }
  // Outside a fetched layer/campaign, inherit the main Touchstone filter period.
  const now = Date.now();
  return [start ?? now - 90 * DAY_MS, end ?? now];
};
